@if (show()) {
  <div class="ita-reconnect-banner" role="alert" [attr.dir]="isRtl() ? 'rtl' : 'ltr'">
    <mat-icon class="warn-icon" aria-hidden="true">warning</mat-icon>
    <span class="banner-text">{{ 'banner.itaReconnect.message' | translate: { date: (reconnectBy() | date:'mediumDate':'+0200') } }}</span>
    <a class="banner-cta" mat-button routerLink="/business-settings">{{ 'banner.itaReconnect.cta' | translate }}</a>
    <button
      mat-icon-button
      class="dismiss-btn"
      (click)="dismiss()"
      [attr.aria-label]="'common.dismiss' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
